import React from 'react';
import { Typography, TypographyProps } from '@mui/material';

export interface NavBarTitleProps
  extends Pick<TypographyProps, 'sx' | 'onClick'> {
  children: React.ReactNode;
  dataTestId?: string;
}

export default function NavBarTitle({
  dataTestId,
  children,
  onClick,
  sx,
}: NavBarTitleProps) {
  return (
    <Typography sx={sx} onClick={onClick} variant="h6" data-testid={dataTestId}>
      {children}
    </Typography>
  );
}
